export default __webpack_public_path__ + "static/17-698af2155dda3afa16c535a8feb96b2d.jpg";